export { default as UserFinanceDebitBadgeLink } from './UserFinanceDebitBadgeLink';
